import React from "react";

import StyledButton from "./button.styled";

export type ButtonProps = {
  isDisabled?: boolean;
  variant?: "text" | "contained" | "outlined";
  textColor: string;
  text: string;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  type: "button" | "submit";
  color?: "primary" | "secondary" | "neutral" | "dark" | "error";
  fontFamily?: "NotoSans-SemiBold" | "NotoSans-Medium" | "Outfit-SemiBold";
  fontSize?: string;
  iscta?: boolean;
  onClick: () => void;
};

const Button = ({
  isDisabled = false,
  variant = "contained",
  textColor,
  text,
  startIcon,
  endIcon,
  iscta,
  fontFamily,
  fontSize,
  type,
  color,
  onClick,
}: ButtonProps) => {
  return (
    <StyledButton
      iscta={iscta ? "true" : undefined}
      fontFamily={fontFamily}
      fontSize={fontSize}
      textcolor={textColor}
      color={color}
      disabled={isDisabled}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      type={type}
      onClick={onClick}
    >
      {text}
    </StyledButton>
  );
};

export default Button;
